<template>
  <div id="app">
    <Header />
    <maintenance-notification v-if="isMaintenanceMode" />
    <div v-if="$auth.loading" class="app-auth-loading">
      <Spinner />
    </div>
    <transition v-else name="fade" mode="out-in">
      <router-view class="page-content" />
    </transition>
    <Footer />
    <DastPromoBlock />
    <AppToast />
  </div>
</template>

<script>
import Header from './components/Header';
import Footer from './components/Footer';
import MaintenanceNotification from './components/MaintenanceNotification.vue';
import DastPromoBlock from './components/DastPromoBlock.vue';
import AppToast from './_core/shared/ui/AppToast/AppToast.vue';
import Spinner from './components/Spinner.vue';
import { MAINTENANCE_MODE_ENABLED } from './utils/constants/common';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    MaintenanceNotification,
    DastPromoBlock,
    AppToast,
    Spinner,
  },
  data() {
    return {
      isMaintenanceMode: MAINTENANCE_MODE_ENABLED,
    };
  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path) this.scroll();
    },
  },
  created() {
    this.captureUtmParameters();
  },
  methods: {
    scroll: function () {
      return window.scrollTo(0, 0);
    },
    captureUtmParameters() {
      // Only capture UTM parameters if none are already stored
      const existingUtmData = localStorage.getItem('oversecured_utm_data');

      if (!existingUtmData) {
        const urlParams = new URLSearchParams(window.location.search);
        const hasUtmParams =
          urlParams.has('utm_source') ||
          urlParams.has('utm_medium') ||
          urlParams.has('utm_campaign') ||
          urlParams.has('utm_term') ||
          urlParams.has('utm_content');

        if (hasUtmParams) {
          const utmData = {
            source: urlParams.get('utm_source') || '',
            medium: urlParams.get('utm_medium') || '',
            campaign: urlParams.get('utm_campaign') || '',
            term: urlParams.get('utm_term') || '',
            content: urlParams.get('utm_content') || '',
            timestamp: Date.now(),
          };

          localStorage.setItem('oversecured_utm_data', JSON.stringify(utmData));

          if (process.env.NODE_ENV === 'production' && typeof gtag !== 'undefined') {
            gtag('event', 'utm_captured', {
              utm_source: utmData.source,
              utm_medium: utmData.medium,
              utm_campaign: utmData.campaign,
              utm_term: utmData.term,
              utm_content: utmData.content,
            });
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.app-auth-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}
</style>
